import { useSyncExternalStore } from 'react'
import { buildTime } from './clock'

function subscribeToNothing() {
  return () => {}
}

export function useHydrated(): boolean {
  return useSyncExternalStore(
    subscribeToNothing,
    () => true,
    () => false,
  )
}

export function useCurrentTime(): Date {
  return useHydrated() ? new Date() : buildTime()
}
